import { InputNumber } from 'antd';
import * as React from 'react';

type Props = {
    value: number | undefined;
    onChange: (value: number | undefined) => void;
};

const MinDocCountFilter: React.FC<Props> = ({ value, onChange }) => {
    const handleChange = (val: number | string | null) => {
        const numVal = typeof val === 'string' ? parseInt(val, 10) : val;

        if (numVal == null || numVal === 0 || Number.isNaN(numVal)) {
            onChange(undefined);
        } else {
            onChange(numVal);
        }
    };

    return (
        <InputNumber
            data-id="min-doc-count-filter"
            value={value}
            onChange={handleChange}
            min={0}
            placeholder="Min docs in last run"
            style={{ width: 180 }}
        />
    );
};

export default MinDocCountFilter;
